// extracted by mini-css-extract-plugin
export default {"confirm-delete-custom-call-type-button":"ConfirmDeleteCustomCallTypeButton_confirm-delete-custom-call-type-button__bZBfP"};